// Restrict consent, not the assistant's natural-language requests.
export function voiceDecision(text) {
  const value = String(text).toLocaleLowerCase("fi-FI").normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").replace(/[.,!?;:]/g, " ").replace(/\s+/g, " ").trim();
  if (/^(ei|ei kiitos|peru|peruuta|hylkaa|unohda se|ala (tee|tallenna|hyvaksy)( sita| tata| se)?( nyt)?)$/.test(value)) return "cancel";
  // The entire utterance must consent: 'yes, but change...' is not approval.
  if (/^(hyvaksyn|hyvaksy|vahvista|tallenna|kylla|joo|juu|jep|okei|ok|sopii|anna menna)( (sen|se|tama|taman|ehdotuksen|ehdotus|nyt|vaan|kiitos)){0,3}$/.test(value)) return "approve";
  return null;
}
